
const $ = require('jquery');

// const velocity = require('rgs-velocity-animate');


// TODO: Use velocity instead of jquery

module.exports = {
	fadeIn: function (el) {
		return $(el).fadeIn(500).promise();
	},

	fadeOut: function (el) {
		return $(el).fadeOut(500).promise();
	},

	slideUp: function (el) {
		return $(el)
			.animate({
				opacity: 'hide',
				height: 'hide',
				'margin-bottom': 'hide',
				'margin-top': 'hide',
				'padding-bottom': 'hide',
				'padding-top': 'hide',
			}, { duration: 500 })
			.promise();
	},

	slideDown: function (el) {
		return $(el)
			.animate({
				opacity: 'show',
				height: 'show',
				'margin-bottom': 'show',
				'margin-top': 'show',
				'padding-bottom': 'show',
				'padding-top': 'show',
			}, { duration: 500 })
			.promise();
	},
};


